(function () {
  const L = "[barrel-masters]";
  console.log(L, "script loaded");

  const grid = document.getElementById("barrel-masters-grid");
  if (!grid) {
    console.warn(
      L,
      "no #barrel-masters-grid element found — template not on this page",
    );
    return;
  }
  console.log(L, "grid element found, fetching /apps/barrelmasters/list");

  const fallbackAvatar = grid.dataset.fallbackAvatar || "";

  fetch("/apps/barrelmasters/list", { credentials: "same-origin" })
    .then((r) => {
      console.log(
        L,
        "response status:",
        r.status,
        "content-type:",
        r.headers.get("content-type"),
      );
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    })
    .then((data) => {
      const barrelMasters = (data && data.barrelMasters) || [];
      console.log(
        L,
        "received",
        barrelMasters.length,
        "barrel masters:",
        barrelMasters,
      );
      if (barrelMasters.length === 0) {
        grid.innerHTML =
          '<div class="barrel-masters-status">No Barrel Masters yet.</div>';
        return;
      }
      grid.innerHTML = barrelMasters.map(renderCard).join("");
      console.log(L, "rendered", barrelMasters.length, "cards");
    })
    .catch((err) => {
      console.error(L, "failed to load:", err);
      grid.innerHTML =
        '<div class="barrel-masters-error">Couldn\'t load Barrel Masters. Please try again later.</div>';
    });

  function renderCard(bm) {
    const name = bm.name || "Barrel Master";
    const avatar = bm.profilePicture || fallbackAvatar;
    const href =
      "/pages/profiles?customer_id=" +
      encodeURIComponent(bm.customerId) +
      "&pb=0";
    return (
      '<a class="barrel-master-card" href="' +
      escapeAttr(href) +
      '">' +
      '<img class="barrel-master-card-avatar" src="' +
      escapeAttr(avatar) +
      '" alt="' +
      escapeAttr(name) +
      '" loading="lazy">' +
      '<div class="barrel-master-card-name">' +
      escapeHTML(name) +
      "</div>" +
      "</a>"
    );
  }

  function escapeHTML(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function escapeAttr(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }
})();
